var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portals"},_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"portal"},[_c('OptimisedImage',{staticClass:"portal__image",attrs:{"src":image,"fit":"contain"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }